var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"drag-icon-wrap"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"长按拖拽排序","placement":"top"}},[_c('span',{staticClass:"el-icon-Group-50 drag-icon"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }